var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"dark":"","block":"","color":"orange"},on:{"click":_vm.openSelectionModal}},[_vm._v("\n   Selecionar Pagamentos \n")])
}
var staticRenderFns = []

export { render, staticRenderFns }